const GLOBAL_NEEDLE = /%s/

class UtilityHelper {
  static formatString(subject: string | null | undefined, ...data: string[]): string {
    if (!subject) return ''

    if (GLOBAL_NEEDLE.test(subject))
      return data.reduce((result, replace) => result.replace(GLOBAL_NEEDLE, replace), subject)

    return data.reduce((result, replace, i) => result.replace(new RegExp(String.raw`\{${i}\}`, 'g'), replace), subject)
  }
}

export default UtilityHelper
